<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  background-color: #f5f5f5;
  color: #333;
  line-height: 1.5;
}
@media (min-width: 1000px) { /* 当父元素宽度大于600px时 */
  .page-container {
    width: 50%; /* 子元素宽度设为父元素宽度的50% */
  }
}
.page-container {
  margin: 0 auto;
  background-color: #fff;
  min-height: 100vh;
  position: relative;
}

.header {
  background: linear-gradient(135deg, #1e88e5 0%, #0d47a1 100%);
  color: white;
  padding: 20px 15px;
  position: relative;
  width: 100%;
}

.header .time {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.header .title {
  font-size: 14px;
  margin-bottom: 5px;
}

.header .subtitle {
  font-size: 14px;
  opacity: 0.9;
}

.content {
  padding: 20px 15px;
}

.visitor-info {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 25px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.info-item {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.info-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.info-label {
  font-size: 14px;
  color: #666;
}

.info-value {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}

.info-value.highlight {
  color: #1e88e5;
}

.upload-section {
  margin-bottom: 25px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 8px;
  color: #1e88e5;
}

.photo-upload-area {
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  padding: 30px 15px;
  text-align: center;
  background-color: #fafafa;
  cursor: pointer;
  transition: all 0.3s;
}

.photo-upload-area:hover {
  border-color: #1e88e5;
}

.photo-upload-area .upload-icon {
  font-size: 36px;
  color: #c0c4cc;
  margin-bottom: 10px;
}

.photo-upload-area .upload-text {
  font-size: 14px;
  color: #909399;
}

.photo-upload-area .upload-hint {
  font-size: 12px;
  color: #c0c4cc;
  margin-top: 5px;
}

.photo-preview {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  object-fit: cover;
  margin: 10px auto;
  display: block;
}

.id-card-section {
  margin-bottom: 30px;
}

.agreement {
  font-size: 12px;
  color: #909399;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.6;
}

.agreement a {
  color: #1e88e5;
  text-decoration: none;
}

.submitx-btn {
  width: 100%;
  /*background: linear-gradient(135deg, #1e88e5 0%, #0d47a1 100%);*/
  background: #1e88e5;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 14px 20px;
  font-size: 16px;
  width: 100%;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 6px rgba(30, 136, 229, 0.2);
}

.submitx-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(30, 136, 229, 0.3);
}

.submitx-btn:active {
  transform: translateY(0);
}

.but-disabled{
  color: #fff!important;
  background-color: #a0cfff!important;
  border-color: #a0cfff!important;
}

.footer {
  text-align: center;
  padding: 20px 15px;
  color: #909399;
  font-size: 12px;
  border-top: 1px solid #eee;
  margin-top: 20px;
}

.footer .logo {
  font-size: 16px;
  font-weight: 500;
  color: #1e88e5;
  margin-bottom: 8px;
}

.empty-photo {
  color: #f56c6c;
}

.success-photo {
  color: #67c23a;
}

@media (max-width: 375px) {
  .content {
    padding: 15px 12px;
  }

  .visitor-info {
    padding: 12px;
  }

  .section-title {
    font-size: 15px;
  }
}
.expired-container{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.expired-text{
  width: 100%;
  text-align: center;
}
.expired-container .expired-text .text{
  color: gray;
  margin-top: 10px;
}
.auth_text{
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow-wrap: break-word;
}
::v-deep .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
  color: #FFF!important;
  background-color: #a0cfff!important;
  border-color: #a0cfff!important;
}
</style>

<template>
  <div class="page-container">
    <!-- 头部 -->
    <div class="header">
      <div class="time">您好</div>
      <div class="title">欢迎来访「{{ visitorInfo?.company?.name }}」</div>
    </div>

    <!-- 内容区域 -->
    <div class="content">
      <!-- 访客信息 -->
      <div class="visitor-info">
        <div class="info-item">
          <div class="info-label">被访人</div>
          <div class="info-value">{{ visitorInfo?.user?.name }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">被访人手机号</div>
          <div class="info-value">{{ visitorInfo?.user?.phone }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">预约到访时间</div>
          <div class="info-value highlight">{{ visitorInfo.visitDate }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">预计离访时间</div>
          <div class="info-value highlight">{{ visitorInfo.visitEndDate }}</div>
        </div>
      </div>

      <!-- 人脸照片上传 -->
      <div class="upload-section" v-if="visitorInfo?.company?.enabledFace">
        <div class="section-title">
          <i class="el-icon-camera"></i> 人脸照片
        </div>
        <div class="photo-upload-area" @click="triggerFileInput">
          <div v-if="!photoPreview">
            <div class="upload-icon">
              <i class="el-icon-upload"></i>
            </div>
            <div class="upload-text">上传您的正脸照片，用于开启访客通行门禁设备</div>
            <div class="upload-hint">点击或拖拽上传</div>
          </div>
          <div v-else>
            <img :src="photoPreview" class="photo-preview" alt="人脸照片">
            <div class="upload-text success-photo">照片已上传，点击可重新上传</div>
          </div>
          <input
              type="file"
              name="file"
              ref="fileInput"
              @change="handlePhotoUpload"
              accept="image/jpg"
              style="display: none;"
          >
        </div>
        <div v-if="photoError" class="upload-text empty-photo" style="margin-top: 10px;">
          <i class="el-icon-warning"></i> {{ photoError }}
        </div>
      </div>

      <!-- 身份证输入 -->
      <div class="id-card-section" v-if="visitorInfo?.company?.enabledCard">
        <div class="section-title">
          <i class="el-icon-user"></i> 身份证
        </div>
        <el-input
            v-model="visitorInfo.idno"
            placeholder="请输入"
            @focus="handleIdCardFocus"
            @blur="handleIdCardBlur"
        ></el-input>
        <div v-if="idCardError" class="upload-text empty-photo" style="margin-top: 10px;">
          <i class="el-icon-warning"></i> {{ idCardError }}
        </div>
      </div>

      <!-- 协议 -->
      <div class="agreement">
        <el-radio v-model="checked" :label="true">
          <span class="auth_text">
            提交即同意授权我们收集以上信息，详细请阅读
            <a href="javascript:void(0);" @click="showServiceAgreement">《科密智枢服务协议》</a>
            和
            <a href="javascript:void(0);" @click="showPrivacyPolicy">《科密智枢隐私政策》</a>。
          </span>
        </el-radio>

      </div>

      <!-- 提交按钮 -->
      <button :class="!checked?'but-disabled submitx-btn':'submitx-btn'" :disabled="!checked" type="primary" :loading="loading" @click="handleSubmit">提交</button>
    </div>

    <!-- 底部 -->
    <div class="footer">
      <div class="logo">
        <img src="@/assets/visitor/comte.png"/>
      </div>
      <div>CopyRight@2023广州科密信息技术有限公司-粤ICP备2023127373号</div>
    </div>

    <!-- 服务协议弹窗 -->
    <el-dialog
        title="科密智枢服务协议"
        :visible.sync="showServiceDialog"
        width="90%"
        center>
      <div style="max-height: 300px; overflow-y: auto; font-size: 14px; line-height: 1.6;">
        <p>欢迎使用科密智枢服务！</p>
        <p>在您使用本服务前，请仔细阅读本协议。您使用本服务即视为您已阅读并同意本协议的约束。</p>
        <h4>一、服务内容</h4>
        <p>科密智枢为您提供访客登记、门禁管理、安全监控等服务。</p>
        <h4>二、用户义务</h4>
        <p>您应确保提供的信息真实、准确、完整，并遵守相关法律法规。</p>
        <h4>三、隐私保护</h4>
        <p>我们将依法保护您的个人信息，具体见《科密智枢隐私政策》。</p>
        <h4>四、其他</h4>
        <p>本协议最终解释权归科密智枢所有。</p>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showServiceDialog = false">我已阅读</el-button>
      </span>
    </el-dialog>

    <!-- 隐私政策弹窗 -->
    <el-dialog
        title="科密智枢隐私政策"
        :visible.sync="showPrivacyDialog"
        width="90%"
        center>
      <div style="max-height: 300px; overflow-y: auto; font-size: 14px; line-height: 1.6;">
        <p>科密智枢重视您的隐私保护，本政策说明了我们如何收集、使用和保护您的个人信息。</p>
        <h4>一、信息收集</h4>
        <p>我们可能收集您的姓名、电话号码、身份证信息、人脸照片等。</p>
        <h4>二、信息使用</h4>
        <p>收集的信息将用于访客身份验证、门禁通行、安全管理等目的。</p>
        <h4>三、信息保护</h4>
        <p>我们将采取合理的安全措施保护您的个人信息，防止未经授权的访问、使用或泄露。</p>
        <h4>四、信息共享</h4>
        <p>除非法律要求或经您同意，我们不会与第三方共享您的个人信息。</p>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showPrivacyDialog = false" >我已阅读</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import {VisitorApplyApi} from "@/api/server/visitorApply";

export default {
  components: {},
  props: {
    visitorInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      checked: false,
      photoPreview: '',
      photoError: '',
      idCardError: '',
      isSubmitting: false,
      showServiceDialog: false,
      showPrivacyDialog: false,
      file: null,
      loading: false
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handlePhotoUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.photoError = '请上传图片文件';
        return;
      }

      // 验证文件大小（最大5MB）
      // if (file.size > 5 * 1024 * 1024) {
      //   this.photoError = '图片大小不能超过5MB';
      //   return;
      // }
      this.file = file;
      // 创建预览
      const reader = new FileReader();
      reader.onload = (e) => {
        this.photoPreview = e.target.result;
        this.photoError = '';
      };
      reader.readAsDataURL(file);
      // this.file = this.readFileAsBase64(file);
    },
    readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    handleIdCardFocus() {
      this.idCardError = '';
    },

    handleIdCardBlur() {
      if (this.idCard && !this.validateIdCard(this.visitorInfo.idno)) {
        this.idCardError = '身份证格式不正确';
      } else {
        this.idCardError = '';
      }
    },

    validateIdCard(idCard) {
      // 简单验证身份证格式（实际项目中需要更严格的验证）
      const reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
      // //身份证正则表达式(15位)
      // const isIDCard1=/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
      // //身份证正则表达式(18位)
      // const isIDCard2=/^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{4}$/;
      return reg.test(idCard);
    },

    showServiceAgreement() {
      this.showServiceDialog = true;
    },

    showPrivacyPolicy() {
      this.showPrivacyDialog = true;
    },

    handleSubmit() {
      // 验证照片是否上传 。（只开启了人脸时验证人脸照片）
      if (!this.photoPreview && (!this.visitorInfo?.company?.enabledCard && this.visitorInfo.company.enabledFace && !this.visitorInfo.company.enabledQrcode && !this.visitorInfo.company.enabledPassword)) {
        this.photoError = '请上传人脸照片';
        this.$message.error('请上传人脸照片');
        return;
      }
      // 验证身份证 （只开启了卡片时验证身份证）
      if (!this.visitorInfo.idno && (this.visitorInfo?.company?.enabledCard && !this.visitorInfo.company.enabledFace && !this.visitorInfo.company.enabledQrcode && !this.visitorInfo.company.enabledPassword)) {
        this.idCardError = '请输入身份证号码';
        this.$message.error('请输入身份证号码');
        return;
      }
      // 开启人脸/卡片，其他未开启时必须输入身份证号码或者人脸照片
      if((this.visitorInfo?.company?.enabledCard && this.visitorInfo.company.enabledFace) && !this.visitorInfo.company.enabledQrcode && !this.visitorInfo.company.enabledPassword){
        if(!this.photoPreview && !this.visitorInfo.idno){
          this.photoError = '请上传人脸照片或输入身份证号码';
          this.$message.error('请上传人脸照片或输入身份证号码');
          return;
        }
      }
      if (this.visitorInfo.idno && !this.validateIdCard(this.visitorInfo.idno)) {
        this.idCardError = '身份证格式不正确';
        this.$message.error('身份证格式不正确');
        return;
      }
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append("id", this.visitorInfo.id);
      formData.append("idno", this.visitorInfo.idno || '');
      this.loading = true;
      // const params = {file: this.photoPreview, id : this.visitorInfo.id, idno: this.visitorInfo.idno || ''}
      VisitorApplyApi.submitShareConfirmStatus(formData).then(response => {
        if(response.code == 200){
          this.$message.success("提交成功");
          this.$emit('refresh');
        }else{
          this.$message.error(response.message || "提交失败");
        }
      }).finally(() => {
        this.loading = false;
      })
    }
  }
};
</script>